import React from 'react';
import logo from './VDC_AIPoweredCloudPacs.jpg';

const VDC_AIPoweredCloudPacs = () => {
    return(
        <img
            className="ai-powered-cloud-image"
            src={logo}
            alt="AI Powered Cloud Pacs"
          />
    );
}

export default VDC_AIPoweredCloudPacs